import i18next from 'i18next';
import HttpApi from 'i18next-http-backend';

export const initI18n = i18next.use(HttpApi).init({
  backend: { loadPath: '/locales/{{lng}}/translation.json' },
  fallbackLng: 'en',
  supportedLngs: ['en', 'de'],
  interpolation: { escapeValue: false },
});

const t = i18next.t;
const changeLanguage = i18next.changeLanguage;

export { t, changeLanguage };
export default i18next;
